module.exports = __webpack_public_path__ + "media/St 4-washer dryer-correct.1c120651.wav";